/* eslint-disable unicorn/filename-case */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import _ from 'lodash'
import { MetadataContent } from '@jutro/legacy/uiconfig';
import messages from '../../addressMessages.messages';
import addressControl from '../../util/addressControl';
import metadata from './TWIAStandardizationStatus.metadata.json5';

function TWIAStandardizationStatus(props) {
    const { primaryAddressVM, status, isStandardizationDisabled, noMatchFound, xPortal} = props;
    const [ address, setAddress ] = useState(primaryAddressVM);
    
    useEffect(() => {
        setAddress(primaryAddressVM)
    }, [primaryAddressVM])
    
    const getStandardizedInfoMessage = (anAddress) => {
        if (status) {
            return addressControl.isStdBtnAvailable(anAddress, xPortal)
                ? messages.nonStandardizedMessage 
                : noMatchFound 
                    ? messages.overridden 
                    : messages.standardizedMessage;
        }
        return '';
    };
    
    const overrideProps = {
        mailingInfoMessage: {
            visible: _.get(primaryAddressVM, 'country') === 'US',
            type: addressControl.isStdBtnAvailable(address, xPortal) ? 'error' : noMatchFound ? 'info' : 'success' ,
            message: getStandardizedInfoMessage(address)
        },
        mailingErrorMessage: {
            type: 'error',
            visible: isStandardizationDisabled,
            message: messages.standardizationErrorMessage
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
        />
    );
}

export default TWIAStandardizationStatus;
